import React from 'react';
import { Badge } from './Badge';
export interface Tab {
  id: string;
  label: string;
  count?: number;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}
export function Tabs({
  tabs,
  activeTab,
  onChange,
  className = ''
}: TabsProps) {
  return <div className={`border-b border-gray-200 ${className}`} data-id="element-265">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs" data-id="element-266">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onChange(tab.id)} className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2 transition-colors
                ${isActive ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `} aria-current={isActive ? 'page' : undefined} data-id="element-267">
              {tab.label}
              {tab.count !== undefined && <Badge variant={isActive ? 'blue' : 'neutral'} className="ml-1.5" data-id="element-268">
                  {tab.count}
                </Badge>}
            </button>;
      })}
      </nav>
    </div>;
}